import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledWhereSummary = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  min-width: ${container('xs2')};
  margin-top: ${spacing('sm')};
  margin-bottom: ${spacing('lg')};
  border-top: 1px solid ${color('midnight_200')};
  border-bottom: 1px solid ${color('midnight_200')};
`;

export const StyledWhereSummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};
`;

export const StyledWhereSummaryItemTitle = styled.h3`
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  line-height: 1;
  color: ${color('text_subtle')};
  margin-top: 0;
  margin-bottom: ${spacing('xs2')};
`;

export const StyledWhereSummaryValue = styled.div`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl4')};
  font-weight: ${fontWeight('light')};
  text-transform: uppercase;
  line-height: 1;
`;

export const StyledWhereSummarySeparator = styled.span`
  flex-grow: 0;
  font-family: ${fontFamily('serif')};
  font-style: italic;
  font-size: ${fontSize('xl2')};
  color: ${color('text_subtle')};
  line-height: 1;
  margin: 0 ${spacing('md')};
  padding-bottom: ${spacing('md')};
  align-self: flex-end;

  @media (min-width: ${screen('md')}) {
    margin: 0 ${spacing('xl')};
  }
`;

export const StyledSummaryRemoteWrapper = styled.div`
  display: flex;
`;
